import { createReducer, on } from '@ngrx/store';
import * as OrganizationActions from '../actions/organization.actions';
import { SessionStorage } from '@unico-people/shared/utils/storage';

export interface OrganizationState {
  groups: any;
  currentAccount: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: OrganizationState = {
  groups: [],
  currentAccount: {},
  loaded: false,
  loading: false
};

const loadOrganizationReducer = createReducer(
  initialState,
  on(OrganizationActions.loadOrganization, state => ({ ...state, loading: true })),
  on(OrganizationActions.loadOrganizationSuccess, (state, { payload }) => {
    const current = SessionStorage.getItem('currentAccount');
    const groups = payload;

    let currentAccount = groups[0].accounts[0];
    const companies = groups.reduce((all, item) => {
      item.accounts.map(res => {
        all.push(res);
      });
      return all;
    }, []);

    if (current !== null) {
      currentAccount = companies.filter(x => x.uid === SessionStorage.getItem('currentAccount'))[0];
    }

    return { ...state, currentAccount, groups, loaded: true, loading: false };
  }),
  on(OrganizationActions.loadOrganizationFail, state => ({ ...state, loading: false, loaded: false })),
  on(OrganizationActions.changeAccount, (state, { payload }) => {
    const currentAccount = payload;
    return { ...state, currentAccount, loading: false, loaded: true };
  })
);

export function reducer(state, action) {
  return loadOrganizationReducer(state, action);
}

export const getOrganizationGroups = (state: OrganizationState) => state?.groups;
export const getOrganizationCurrent = (state: OrganizationState) => state?.currentAccount;
export const getOrganizationLoading = (state: OrganizationState) => state?.loading;
export const getOrganizationLoaded = (state: OrganizationState) => state?.loaded;
